import { PureComponent } from 'react';

import DropDownButton from './DropDownButton';

import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';

import { faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class AlignmentControls extends PureComponent {
  toggleAlignment = alignmentStyle => () => {
    const { onUpdateBlockData } = this.props;
    onUpdateBlockData({ alignment: alignmentStyle === 'left' ? undefined : alignmentStyle });
  };

  render() {
    const { blockData } = this.props;
    const activeAlignment = (blockData && blockData.get('alignment')) || 'left';
    const activeAlignmentConfig = ALIGNMENTS[activeAlignment];
    return (
      <DropDownButton
        icon={
          <>
            <FontAwesomeIcon fixedWidth icon={activeAlignmentConfig.icon} />
            <FontAwesomeIcon fixedWidth icon={faCaretDown} size="xs" />
          </>
        }
        menu
        ToolbarButtonProps={{ active: true }}
        tooltip="alignment"
      >
        {Object.values(ALIGNMENTS).map(({ icon, label, type }, i) => (
          <MenuItem key={i} onMouseDown={this.toggleAlignment(type)} selected={activeAlignment === type}>
            <FontAwesomeIcon fixedWidth icon={icon} style={{ marginRight: 16 }} />
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </DropDownButton>
    );
  }
}

const ALIGNMENTS = {
  left: {
    icon: faAlignLeft,
    label: 'Left align',
    type: 'left',
  },
  center: {
    icon: faAlignCenter,
    label: 'Center align',
    type: 'center',
  },
  right: {
    icon: faAlignRight,
    label: 'Right align',
    type: 'right',
  },
  justify: {
    icon: faAlignJustify,
    label: 'Justify align',
    type: 'justify',
  },
};
